import { useCallback, KeyboardEvent } from 'react';
import { useForm } from 'react-hook-form';

import { BaseSwingThreadInput } from '../BaseSwingThreadInput';
import { ArrowCircleUpIcon } from '../../../icons';
import { colors } from '../../../../colors';

import * as css from './SwingThreadInput.css';

type FormValues = { message: string };

type SwingThreadInputProps = {
    threadId: number;
    onSubmit: (payload: { message: string; id?: number; threadId: number }) => void;
};

export const SwingThreadInput = ({ threadId, onSubmit }: SwingThreadInputProps) => {
    const { register, handleSubmit, reset } = useForm<FormValues>({
        mode: 'onChange',
    });

    const handleSubmitMessage = useCallback(
        (data: FormValues) => {
            const trimmed = data.message.trim();
            if (!trimmed) return;
            onSubmit({ message: trimmed, threadId });
            reset({ message: '' });
        },
        [onSubmit, reset, threadId],
    );

    const handleKeyDown = useCallback(
        (e: KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(handleSubmitMessage)();
            }
        },
        [handleSubmit, handleSubmitMessage],
    );

    return (
        <form className={css.form}>
            <BaseSwingThreadInput
                className={css.formTextArea}
                placeholder="Reply"
                {...register('message', { required: true })}
                onKeyDown={handleKeyDown}
                noResize
                noOverflow
            />
            <button onClick={handleSubmit(handleSubmitMessage)} className={css.formArrow}>
                <ArrowCircleUpIcon size={24} weight="fill" color={colors.teal[400]} />
            </button>
        </form>
    );
};
